import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import List from "../Components/SalesTarget/List";
import Add from "../Components/SalesTarget/Add";
//import View from "../Components/SalesTarget/View";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import YearList from "../Components/SalesTarget/YearList";
import View from "../Components/SalesTarget/View";
import HrYearList from "../Components/SalesTarget/HrYearList";
import HrView from "../Components/SalesTarget/HrView";
import { SettingsSystemDaydreamRounded } from "@mui/icons-material";
import * as utils from "../Utils/comman";

function SalesTarget() {
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const isHR = utils?.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Hr_permissions"
  );

  const isSuperAdmin = utils?.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Super_Admin_permissions"
  );
  const [comp, setComp] = useState(isHR || isSuperAdmin ? "HrView" : "list");

  const [rowData, setRowData] = useState();
  const [userData, setUserData] = useState();

  const location = useLocation();

  useEffect(() => {
    console.log("Is it admin or hr", isSuperAdmin);
    isHR || isSuperAdmin ? setComp("HrView") : setComp("list");
  }, [location, isHR, isSuperAdmin]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
    setUserData(newValue.userData);
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Sales Target</h1>
          </div>

          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "view" ? (
            <YearList
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              userData={userData}
            />
          ) : comp === "HrView" ? (
            <HrYearList comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "HrMboView" ? (
            <HrView comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "MBOView" ? (
            <View
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              userData={userData}
            />
          ) : (
            <Add comp={comp} rowData={rowData} onChange={handleChange} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default SalesTarget;
